import { TableColumns } from "../../../../core/models/dashboard/tableColumns";

export const columns: TableColumns[] = [
  {
    header: "Order Date",
    field: "orderDate",
    link: false,
    linkField: "",
    isDate: true,
    isNumber: false,
  },
  {
    header: "Order #",
    field: "salesOrderId",
    link: true,
    linkField: "salesOrderId",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Stat",
    field: "stat",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Client Name",
    field: "clientName",
    link: true,
    linkField: "customerAccountNumber",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Job Name",
    field: "jobName",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
    isLongValueTrimmed: true,
  },
  {
    header: "Volume",
    field: "volume",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Net Comm",
    field: "netComm",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Net GP%",
    field: "netGPPercentage",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
];
